/**
 * Column definitions for the per-user activity table.
 */

import React from 'react'
import { Chip, Typography } from '@mui/material'
import { TableColumn } from '../../../../components/shared/BaseDataTable'
import RelativeTime from '../../../../components/shared/RelativeTime'
import { ActivityUserRow } from '../../../../services/activityApi'
import { getRoleColor, getRoleDisplayName } from '../../../../utils/roleDisplay'

export const createActivityUserColumns = (): TableColumn<ActivityUserRow>[] => [
  {
    key: 'name',
    label: 'User',
    sortable: true,
    render: (row) => (
      <>
        <Typography variant="body2">{row.name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {row.email}
        </Typography>
      </>
    ),
  },
  {
    key: 'role',
    label: 'Role',
    sortable: true,
    render: (row) => (
      <Chip
        label={getRoleDisplayName(row.role)}
        size="small"
        color={getRoleColor(row.role)}
        variant="outlined"
      />
    ),
  },
  {
    key: 'window_last_seen_at',
    label: 'Last Active (window)',
    sortable: true,
    render: (row) => <RelativeTime value={row.window_last_seen_at} />,
  },
  {
    key: 'event_count',
    label: 'Requests',
    align: 'right',
    sortable: true,
    render: (row) => (
      <Typography variant="body2">{row.event_count.toLocaleString()}</Typography>
    ),
  },
  {
    key: 'action_count',
    label: 'Actions',
    align: 'right',
    sortable: true,
    render: (row) =>
      row.action_count > 0 ? (
        <Chip label={row.action_count.toLocaleString()} size="small" color="success" variant="outlined" />
      ) : (
        <Typography variant="body2" color="text.secondary">
          0
        </Typography>
      ),
  },
  {
    key: 'last_action_at',
    label: 'Last Action',
    sortable: true,
    render: (row) => <RelativeTime value={row.last_action_at} />,
  },
  {
    key: 'last_seen_at',
    label: 'Last Active (all time)',
    sortable: true,
    render: (row) => <RelativeTime value={row.last_seen_at} />,
  },
]
